// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file mantra/mantra.proto (package lvdr.v2.mantra, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mantra/mantra.proto.
 */
export const file_mantra_mantra: GenFile = /*@__PURE__*/
  fileDesc("ChNtYW50cmEvbWFudHJhLnByb3RvEg5sdmRyLnYyLm1hbnRyYSISChBHZXRNYW50cmFSZXF1ZXN0IiUKE1VwZGF0ZU1hbnRyYVJlcXVlc3QSDgoGbWFudHJhGAEgASgJIiAKDk1hbnRyYVJlc3BvbnNlEg4KBm1hbnRyYRgBIAEoCUInWiVnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvbWFudHJhYgZwcm90bzM");

/**
 * Fetch the current user's mantra. Empty string if none set.
 *
 * @generated from message lvdr.v2.mantra.GetMantraRequest
 */
export type GetMantraRequest = Message<"lvdr.v2.mantra.GetMantraRequest"> & {
};

/**
 * Describes the message lvdr.v2.mantra.GetMantraRequest.
 * Use `create(GetMantraRequestSchema)` to create a new message.
 */
export const GetMantraRequestSchema: GenMessage<GetMantraRequest> = /*@__PURE__*/
  messageDesc(file_mantra_mantra, 0);

/**
 * Set (or clear, with an empty string) the current user's mantra.
 *
 * @generated from message lvdr.v2.mantra.UpdateMantraRequest
 */
export type UpdateMantraRequest = Message<"lvdr.v2.mantra.UpdateMantraRequest"> & {
  /**
   * @generated from field: string mantra = 1;
   */
  mantra: string;
};

/**
 * Describes the message lvdr.v2.mantra.UpdateMantraRequest.
 * Use `create(UpdateMantraRequestSchema)` to create a new message.
 */
export const UpdateMantraRequestSchema: GenMessage<UpdateMantraRequest> = /*@__PURE__*/
  messageDesc(file_mantra_mantra, 1);

/**
 * The current mantra, echoed after get or update.
 *
 * @generated from message lvdr.v2.mantra.MantraResponse
 */
export type MantraResponse = Message<"lvdr.v2.mantra.MantraResponse"> & {
  /**
   * @generated from field: string mantra = 1;
   */
  mantra: string;
};

/**
 * Describes the message lvdr.v2.mantra.MantraResponse.
 * Use `create(MantraResponseSchema)` to create a new message.
 */
export const MantraResponseSchema: GenMessage<MantraResponse> = /*@__PURE__*/
  messageDesc(file_mantra_mantra, 2);

